import styled from 'styled-components';
import { ButtonProps } from './';

export const StyledButton = styled.button<ButtonProps>`
  width: ${props => props.sxwidth ? props.sxwidth : '100px'};
  height: ${props => props.sxheight ? props.sxheight : '40px'};
  background-color: ${props => props.color};
  margin-top: ${props => props.sxmargintop ? props.sxmargintop : null};
  margin-left: ${props => props.sxmarginleft ? props.sxmarginleft : null};
  padding: 10px;
  border-radius: 6px;
  cursor: ${props => props.$sxdisabled ? 'not-allowed' : 'pointer'};
  font-weight: bold;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${props => props.sxgap ? props.sxgap : '0px'};


  &:hover {
    background-color: ${props => props.sxhover ? props.sxhover : null};
    transition: 0.2s;
  }
`;
